// All numerical measurements are in px
const button = {
  fontSize: 14,
  height: 44,
  paddingY: 12,
  paddingX: 20,
} as const;

export default button;
